class FilterManager {
    constructor(form) {
        this.DealerOptions = [];
        this.StateOptions = [];
        this.ValidDealerList = [];
        this.ValidStates = new Set();
        const releaseTogglesBlock = document.getElementById("do-release-toggles");
        if (releaseTogglesBlock !== null) {
            const releaseToggles = JSON.parse(releaseTogglesBlock.textContent);
            this._enableGoVirtualDropdownFix =
                releaseToggles?.EnableGoVirtualDropdownFix ?? false;
        }
        form.setAttribute("state-field-set", "true");
        this.initialize(form);
    }
    initialize(form) {
        this.Form = form;
        this.SelDealer = this.Form.querySelector("[id^='selDealer']");
        this.SelState = this.Form.querySelector("[id^='selState']");
        if (this.SelDealer && this.SelState) {
            const inventoryFilterContainer = this.findClosestInventoryWidget(this.SelDealer);
            this.SelMake = (this._enableGoVirtualDropdownFix
                ? inventoryFilterContainer?.querySelector("select[inventory-filter='Make']")
                : this.Form.querySelector("select[inventory-filter='Make']"));
            this.SelDealer.disabled = true;
            this.populateStateOptions();
            this.addEventListeners();
        }
    }
    addEventListeners() {
        /*on forms with inventory, inventorymanager.ts in sitesaa also
            filters the dealer options when the "make" field changes
            */
        this.SelDealer.addEventListener("do.groupdealerlistupdate", (event) => {
            const customEvent = event;
            if (this.ValidDealerList === customEvent.detail.dealers) {
                return;
            }
            this.ValidDealerList = customEvent.detail.dealers;
            //If the user selects the default option this ev is dispatched with an empty array
            if (this.ValidDealerList.length === 0 && this.SelMake?.value === "") {
                this.ValidDealerList = this.DealerOptions.map((option) => option.textContent);
            }
            this.filterStates();
        });
        this.SelState.addEventListener("change", () => this.filterDealers());
    }
    findClosestInventoryWidget(element) {
        const widgets = Array.from(document.querySelectorAll("inventory-widget"));
        if (widgets.length === 0)
            return null;
        // Find the inventory widget nearest to the dealer selection dropdown
        const elementRect = element.getBoundingClientRect();
        let closest = null;
        let minOffset = Number.POSITIVE_INFINITY;
        widgets.forEach((widget) => {
            const widgetRect = widget.getBoundingClientRect();
            const offset = Math.abs(widgetRect.top - elementRect.top);
            if (offset < minOffset) {
                minOffset = offset;
                closest = widget;
            }
        });
        return closest;
    }
    populateStateOptions() {
        let selectedState = "";
        Array.from(this.SelDealer.options)
            .filter((option) => option.hasAttribute("data-state"))
            .sort((a, b) => a.dataset.state.localeCompare(b.dataset.state))
            .forEach((option) => {
            option.disabled = false;
            option.hidden = false;
            const state = option.getAttribute("data-state");
            if (state) {
                this.DealerOptions.push(option);
                this.ValidStates.add(state);
            }
            if (option.selected && state) {
                selectedState = state;
            }
        });
        this.ValidDealerList = this.DealerOptions.map((option) => option.textContent);
        this.ValidStates.forEach((state) => {
            const option = document.createElement("option");
            this.StateOptions.push(option);
            option.value = state;
            option.text = state;
            this.SelState.add(option);
        });
        if (selectedState) {
            this.SelState.value = selectedState;
            this.filterDealers();
        }
    }
    filterStates() {
        this.ValidStates.clear();
        const currentStateOptions = Array.from(this.SelState.options);
        const enabledDealers = this.DealerOptions.filter((option) => this.ValidDealerList.includes(option.textContent));
        enabledDealers.forEach((option) => {
            this.ValidStates.add(option.dataset.state);
        });
        if (enabledDealers.length === 0) {
            // Disable selState if all dealers are disabled
            this.SelState.disabled = true;
            this.SelState.options[0].selected = true;
            this.SelDealer.disabled = true;
            this.SelDealer.options[0].selected = true;
            return;
        }
        this.SelState.disabled = false;
        // Show/hide <options> in selState based on the enabled dealers
        this.StateOptions.forEach((option) => {
            //break if default option
            if (option.value === "") {
                return;
            }
            const state = option.value;
            switch (true) {
                case this.ValidStates.has(state) &&
                    !currentStateOptions.includes(option):
                    this.SelState.add(option);
                    break;
                case !this.ValidStates.has(state) &&
                    currentStateOptions.includes(option):
                    this.SelState.remove(option.index);
                    if (this.SelState.value === option.value) {
                        this.SelDealer.options[0].selected = true;
                        this.SelDealer.disabled = true;
                    }
                    break;
                default:
                    break;
            }
        });
    }
    filterDealers() {
        const currentDealerOptions = Array.from(this.SelDealer.options);
        if (!this.SelState.value) {
            // Disable all <options> if no state is selected
            this.SelDealer.options[0].selected = true;
            this.SelDealer.disabled = true;
            return;
        }
        this.SelDealer.disabled = false;
        // Show/hide <options> based on the selected state
        this.DealerOptions.forEach((option) => {
            switch (true) {
                case this.isValid(option) && !currentDealerOptions.includes(option):
                    option.hidden = false;
                    option.disabled = false;
                    this.SelDealer.add(option);
                    break;
                case !this.isValid(option) && currentDealerOptions.includes(option):
                    this.SelDealer.remove(option.index);
                    break;
                case this.isValid(option) && currentDealerOptions.includes(option):
                    //we need this since inventoryManager.ts is still filtering with disable/hidden
                    currentDealerOptions[option.index].disabled = false;
                    currentDealerOptions[option.index].hidden = false;
                    break;
                default:
                    break;
            }
        });
    }
    isValid(option) {
        return (option.dataset.state == this.SelState.value &&
            this.ValidDealerList.includes(option.textContent));
    }
}
FilterManager.instanceCount = 0;
export default FilterManager;
